<template>
  <div class="bg-list-container">
    <div class="bg-list__header">
      <div
        class="bg-list__header-item"
        :style="`width: calc(100% / ${headers.length + actions.length})`"
        v-bind:key="header.value"
        v-for="header in headers"
      >
        {{ header.label }}
      </div>
      <div
        class="bg-list__header-item"
        v-for="(action, index) in actions"
        v-bind:key="`header_action_${index}`"
        :style="`width: calc(100% / ${headers.length + actions.length})`"
      ></div>
    </div>
    <router-link
      :to="`${item.link ? item.link : '#'}`"
      v-for="item in items"
      v-bind:key="item.email"
    >
      <div class="bg-list__item">
        <div
          :class="`bg-list__item-col`"
          v-for="header in headers"
          v-bind:key="header.value"
        >
          <bg-icon
            v-if="header.icon"
            :class="`bg-list__icon bg-list__icon--${item.gender}`"
            :name="item.gender"
          />
          <span :class="`bg-list__icon`" v-if="!header.icon" />
          <bg-icon
            v-if="header.value === 'answers' && item[header.value]"
            :class="`bg-list__icon bg-list__icon--answers`"
            :name="'check'"
          />
          <span
            v-if="!header.format && header.value !== 'answers'"
            class="bg-list__icon-text"
            :style="`${header.color ? 'color: ' + header.color : ''}`"
          >
            {{ item[header.value] }}
          </span>
          <span
            v-if="header.format"
            class="bg-list__icon-text"
            :style="`${header.color ? 'color: ' + header.color : ''}`"
          >
            {{ header.format(item[header.value]) }}
          </span>
        </div>
        <div
          class="bg-list__item-col bg-list__item-col--action"
          v-for="action in actions"
          v-bind:key="action.tooltip"
          v-if="admin || actionPerms"
          :style="`width: calc(100% / ${headers.length + actions.length})`"
        >
          <bg-tooltip dark v-if="action.tooltip">
            <template slot="content">{{ action.tooltip }}</template>
            <template slot="target">
              <bg-icon
                :class="`bg-list__icon--action${
                  item.favourite ? '--active' : ''
                }`"
                :name="action.icon"
              />
            </template>
          </bg-tooltip>
          <div class="bg-list__icon--action-text" v-if="action.text">
            {{ action.text }}
          </div>
        </div>
      </div>
    </router-link>
    <div v-if="admin" class="bg-list__item bg-list__item--add">
      <div
        @click="$router.push({ path: `/add-member` })"
        :colspan="1000"
        class="bg-list__item__add-content"
      >
        <bg-icon class="bg-list__icon bg-list__icon--add" name="close" />
        <span class="bg-list__icon-text">Add a new member</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgTooltip from "@/components/bg-tooltip";

export default {
  name: "BgInput",
  components: {
    BgIcon,
    BgTooltip,
  },
  props: {
    items: Array,
    headers: Array,
    actions: Array,
    admin: Boolean,
    actionPerms: Boolean,
  },
  data() {
    return {
      input: this.value,
    };
  },
};
</script>
